// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected_table_actions {
    display: flex;
    align-items: center;
    position: relative;
}
.selected_table_actions > p {
    font-size: 0.9rem;
    color: rgba(142, 148, 153, 0.9);
    padding-right: 0.5rem;
    font-weight: 500;
}
.selected_actions_dots {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(118, 116, 147, 0.11);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin-right: 30px;
    transition: 0.3s;
}

.selected_actions_dots.selected {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(118, 116, 147, 0.11);
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    margin-right: 30px;
    transform: rotateZ(-90deg);
    transition: 0.3s;
}

.selected_action_dot {
    margin-top: 2px;
    margin-bottom: 2px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #A2ADBF;
}
.selected_actions_menu_hide {
    display: none;
}
.selected_actions_menu {
    width: 207px;
    background-color: white;
    position: absolute;
    right: 65px;
    bottom: -126px;
    z-index: 2;
}

@media (max-width: 600px) {
    .selected_actions_menu {
        width: 207px;
        background-color: white;
        position: absolute;
        left: 0px;
        bottom: -126px;
        z-index: 2;
    }

}

.selected_actions_menu > div {
    display: flex;
    align-items: center;
    height: 55px;
    padding-left: 20px;
    cursor: pointer;
}
.selected_actions_menu > div:not(:last-child) {
    border-bottom: 1px solid rgba(112, 112, 112, 0.11);
}

.selected_actions_menu > div > img {
    width: 15px;
    height: 15px;
    margin-right: 10px;
}

.selected_actions_menu > div > p {
    color: #4B5960;
    font-size: 0.8rem;
    font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/TableSelectedItemActions.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,UAAU;AACd;;AAEA;IACI;QACI,YAAY;QACZ,uBAAuB;QACvB,kBAAkB;QAClB,SAAS;QACT,cAAc;QACd,UAAU;IACd;;AAEJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":[".selected_table_actions {\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n.selected_table_actions > p {\n    font-size: 0.9rem;\n    color: rgba(142, 148, 153, 0.9);\n    padding-right: 0.5rem;\n    font-weight: 500;\n}\n.selected_actions_dots {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: rgba(118, 116, 147, 0.11);\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    margin-right: 30px;\n    transition: 0.3s;\n}\n\n.selected_actions_dots.selected {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: rgba(118, 116, 147, 0.11);\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    margin-right: 30px;\n    transform: rotateZ(-90deg);\n    transition: 0.3s;\n}\n\n.selected_action_dot {\n    margin-top: 2px;\n    margin-bottom: 2px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background-color: #A2ADBF;\n}\n.selected_actions_menu_hide {\n    display: none;\n}\n.selected_actions_menu {\n    width: 207px;\n    background-color: white;\n    position: absolute;\n    right: 65px;\n    bottom: -126px;\n    z-index: 2;\n}\n\n@media (max-width: 600px) {\n    .selected_actions_menu {\n        width: 207px;\n        background-color: white;\n        position: absolute;\n        left: 0px;\n        bottom: -126px;\n        z-index: 2;\n    }\n\n}\n\n.selected_actions_menu > div {\n    display: flex;\n    align-items: center;\n    height: 55px;\n    padding-left: 20px;\n    cursor: pointer;\n}\n.selected_actions_menu > div:not(:last-child) {\n    border-bottom: 1px solid rgba(112, 112, 112, 0.11);\n}\n\n.selected_actions_menu > div > img {\n    width: 15px;\n    height: 15px;\n    margin-right: 10px;\n}\n\n.selected_actions_menu > div > p {\n    color: #4B5960;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
